import { render, staticRenderFns } from "./DependentDetailsCard.vue?vue&type=template&id=28880c92&scoped=true&lang=pug&"
import script from "./DependentDetailsCard.vue?vue&type=script&lang=js&"
export * from "./DependentDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./DependentDetailsCard.vue?vue&type=style&index=0&id=28880c92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28880c92",
  null
  
)

export default component.exports